import { http } from 'utils'
import { set } from 'lodash'

// Payment details mutation imports.
import { SET_PAYMENT_DETAILS, SET_PAYMENT_DETAILS_PROPERTY, RESET_PAYMENT_DETAILS } from 'vx/mutations'

export const initialPaymentDetailsState = () => ({
  id: null,
  bsb_number: null,
  account_name: null,
  account_number: null,
  abn: null,
  gst_registered: null,
  swift_code: null,
  superannuation_number: null,
  member_fund: null,
  spin_number: null,
  member_number: null,
  sole_trader: false,
  statement_by_supplier: null,
  iban_number: null,
  aba_routing_number: null,
  allow_talent_change: false,
  superannuation_number_abn: null
})

// Payment details state.
const state = {
  paymentDetails: initialPaymentDetailsState()
}

// Payment details state getters.
const getters = {}

// Payment details actions.
const actions = {
  getUserPaymentDetails ({ commit }, { id }) {
    commit(RESET_PAYMENT_DETAILS)
    return http.get(`users/${id}/payment_details`)
      .then((response) => {
        commit(SET_PAYMENT_DETAILS, response.data)
      })
  },

  updateUserPaymentDetails (store, { id, payload }) {
    return http.post(`users/${id}/payment_details`, payload)
  },

  setPaymentDetailsProperty ({ commit }, { property, value }) {
    commit(SET_PAYMENT_DETAILS_PROPERTY, { property, value })
  },

  saveCard ({ commit }, { userId, paymentMethodId }) {
    return http.post(`users/${userId}/save_card`, { paymentMethodId })
  }
}

// Payment details state mutations.
const mutations = {
  [SET_PAYMENT_DETAILS] (state, paymentDetails) {
    state.paymentDetails = paymentDetails
  },

  [SET_PAYMENT_DETAILS_PROPERTY] (state, { property, value }) {
    set(state.paymentDetails, property, value)
  },

  [RESET_PAYMENT_DETAILS] (state) {
    state.paymentDetails = initialPaymentDetailsState()
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
